let maxTop = 0;
let initialWidth;
window.dragElement = (idName) => {
  const svgWrapper = document.getElementById(idName);
  const svgElm = svgWrapper.firstElementChild;
  const gElm = document.getElementById("plan");
  let pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;
  svgWrapper.onmousedown = dragMouseDown;

  maxTop =
    svgElm.getBoundingClientRect().top - gElm.getBoundingClientRect().top;
  initialWidth = gElm.getBoundingClientRect().width;

  // console.log(maxTop);
  maxTop -= maxTop * 0.2;
  // console.log(maxTop);

  function dragMouseDown(e) {
    e = e || window.event;
    e.preventDefault();
    pos3 = e.clientX;
    pos4 = e.clientY;
    document.onmouseup = closeDragElement;
    document.onmousemove = elementDrag;
  }

  let closedDrag = false;
  function elementDrag(e) {
    if (closedDrag) null;
    const g = svgWrapper.firstElementChild.firstElementChild;
    e = e || window.event;
    e.preventDefault();
    pos1 = pos3 - e.clientX;
    pos2 = pos4 - e.clientY;
    pos3 = e.clientX;
    pos4 = e.clientY;
    svgWrapper.style.top = `${svgWrapper.offsetTop - pos2}px`;
    svgWrapper.style.left = `${svgWrapper.offsetLeft - pos1}px`;
  }

  function closeDragElement() {
    const gElm = document.getElementById("plan");
    // (40-30)/30 * 100 = 33%
    const percentage =
      ((gElm.getBoundingClientRect().width - initialWidth) / initialWidth) *
      100;
    const percentageDiff = Math.abs((maxTop * percentage) / 100);
    /*
    console.log("maxTop", maxTop);
    console.log("initialWidth", initialWidth);
    console.log("gElm", gElm.getBoundingClientRect().width);
    console.log("percentage", percentage);
    console.log("percentageDiff", percentageDiff);
    */
    if (gElm.getBoundingClientRect().top < 48) {
      svgWrapper.style.top = `${maxTop + percentageDiff}px`;
    }
    document.onmouseup = null;
    document.onmousemove = null;
  }
};
